import { iButtonDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Button/Button';
import { iDataGridDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/DataGrid/DataGrid';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';
import { nameof } from 'ts-simple-nameof/src/nameof';
import { ValidationInfoDisplayOptions } from '../../../templates/dataGrid/column/validation-info-column-template/ValidationInfo';
import { OrderReturnStepItem } from './OrderReturn';

export const orderStepsReturnGridId = 'OrderReturn.orderStepsReturnGrid';
const orderStepsReturnGridOptions: iDataGridDisplayOptions = {
    id: orderStepsReturnGridId,
    columnAutoWidth: true,
    showBorders: false,
    pager: {
        displayMode: 'adaptive',
    },
    columns: [
        {
            dataField: nameof<OrderReturnStepItem>((c) => c.id),
            caption: '#',
            width: '50px',
            cellTemplate: 'RowIndexCircleColumn',
            allowSorting: false,
        },
        {
            dataField: nameof<OrderReturnStepItem>((c) => c.location),
            caption: 't~OrderReturn:column.location',
            cellTemplate: 'RouteLocationModelMultiLineColumn',
            allowSorting: false,
        },
        {
            caption: 't~OrderReturn:column.plannedStartDate',
            width: '150px',
            cellTemplate: 'OrderReturnPlannedStartDateColumn',
            dataType: 'datetime',
            allowSorting: false,
        },
        {
            dataField: nameof<OrderReturnStepItem>((c) => c.type),
            caption: 't~OrderReturn:column.type',
            width: '150px',
            cellTemplate: 'ReturnStepType',
            allowSorting: false,
        },
        {
            dataField: nameof<OrderReturnStepItem>((c) => c.payload!.carrierCount),
            caption: 't~OrderReturn:column.carrierCount',
            width: '80px',
            dataType: 'number',
            allowSorting: false,
        },
        {
            dataField: 'error',
            cellTemplate: 'ValidationInfoColumn',
            caption: '',
            width: '32px',
        },
    ],
};
propsStore.insert(orderStepsReturnGridOptions);

export const orderStepsReturnAddNewLoadPlaceId = 'OrderReturn.orderStepsReturnAddNewLoadPlace';
const orderStepsReturnAddNewLoadPlaceOptions: iButtonDisplayOptions = {
    id: orderStepsReturnAddNewLoadPlaceId,
    //
    icon: 'plus',
    type: 'success',
    stylingMode: 'text',
    //
    text: 't~OrderReturn:addNewLoadPlace',
};
propsStore.insert(orderStepsReturnAddNewLoadPlaceOptions);

export const orderStepsReturnSummaryGridId = 'OrderReturn.orderStepsReturnSummaryGrid';
const orderStepsReturnSummaryGridOptions: iDataGridDisplayOptions = {
    id: orderStepsReturnSummaryGridId,
    showBorders: false,
    columnAutoWidth: true,
    pager: {
        displayMode: 'adaptive',
    },
    //
    columns: [
        {
            dataField: nameof<OrderReturnStepItem>((c) => c.id),
            width: '50px',
            cellTemplate: 'RowIndexCircleColumn',
        },
        {
            dataField: nameof<OrderReturnStepItem>((c) => c.location),
            caption: 't~OrderReturn:column.location',
            cellTemplate: 'RouteLocationModelMultiLineColumn',
        },
        {
            dataField: nameof<OrderReturnStepItem>((c) => c.plannedStartDate),
            caption: 't~OrderReturn:column.plannedStartDate',
            width: '200px',
            dataType: 'datetime',
        },
        {
            dataField: nameof<OrderReturnStepItem>((c) => c.type),
            caption: 't~OrderReturn:column.type',
            width: '200px',
        },
        {
            dataField: nameof<OrderReturnStepItem>((c) => c.payload!.carrierCount),
            caption: 't~OrderReturn:column.carrierCount',
            width: '50px',
            dataType: 'number',
        },
    ],
};
propsStore.insert(orderStepsReturnSummaryGridOptions);

export const orderStepsReturnAddFirstLoadPlaceId = 'OrderReturn.orderStepsReturnAddFirstLoadPlace';
const orderStepsReturnAddFirstLoadPlaceOptions: iButtonDisplayOptions = {
    id: orderStepsReturnAddFirstLoadPlaceId,
    type: 'success',
    stylingMode: 'contained',
    text: 't~OrderReturn:addFirstPlaceButton',
};
propsStore.insert(orderStepsReturnAddFirstLoadPlaceOptions);

export const orderStepsReturnGridErrorInfoColumnId =
    'OrderReturn.orderStepsReturnGrid.column.error';
const orderStepsReturnGridErrorInfoColumnOptions: ValidationInfoDisplayOptions = {
    id: orderStepsReturnGridErrorInfoColumnId,
    validationResult: 'v~validationResult' as any,
    orderErrorInfoDisplayOptions: {
        hideEditButton: true,
        hideOnHoverEnd: true,
        hideTitle: true,
    },
};
propsStore.insert(orderStepsReturnGridErrorInfoColumnOptions);
